import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { TokenService } from './core/services/token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private token: TokenService) {}

  canActivate(): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {
    // Validate email verify
    const user = this.token.get();
    if (!user.emailIsVerified) {
      return false;
    }

    return this.auth.status.pipe(map(data => data ));
  }

}
